import { render } from "./RsmUpdates.vue?vue&type=template&id=f5f938d0&ts=true"
import script from "./RsmUpdates.vue?vue&type=script&lang=ts"
export * from "./RsmUpdates.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/RsmUpdates.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5f938d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5f938d0', __exports__)) {
    api.reload('f5f938d0', __exports__)
  }
  
  module.hot.accept("./RsmUpdates.vue?vue&type=template&id=f5f938d0&ts=true", () => {
    api.rerender('f5f938d0', render)
  })

}


export default __exports__